import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-176">
      {label && <label className="block text-xs font-serif uppercase tracking-widest text-gray-400 mb-2 ml-1" data-id="element-177">
          {label}
        </label>}
      <div className="relative group" data-id="element-178">
        <input className={`
            w-full h-12 px-4 bg-[#0a0a0a] text-gray-200
            border border-[#333] 
            placeholder:text-gray-700
            focus:outline-none focus:border-[#D22B2B] focus:ring-1 focus:ring-[#D22B2B]/50
            disabled:opacity-50 disabled:cursor-not-allowed
            transition-all duration-300
            shadow-inner
            ${error ? 'border-[#D22B2B]' : ''}
            ${className}
          `} {...props} data-id="element-179" />
        {/* Glow line at bottom */}
        <div className="absolute bottom-0 left-0 w-0 h-[1px] bg-[#D22B2B] transition-all duration-500 group-hover:w-full peer-focus:w-full" data-id="element-180"></div>
      </div>
      {error && <p className="mt-1 text-xs text-[#D22B2B] font-serif tracking-wide" data-id="element-181">
          {error}
        </p>}
    </div>;
}